import { createAction } from '@ngrx/store'

export const START_SESSION_TIMEOUT = 'START_SESSION_TIMEOUT'
export const CHECK_SESSION_TIMEOUT = 'CHECK_SESSION_TIMEOUT'

export const startSessionTimeout = createAction(START_SESSION_TIMEOUT)

export const checkSessionTimeout = createAction(CHECK_SESSION_TIMEOUT)
